import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { useStore } from "../../contexts/StoreContext";

function LendingSentry() {
  const { data } = useStore();
  const applicationUuid = data.lendingApplicationID ?? "";

  useEffect(() => {
    if (!applicationUuid) {
      return;
    }

    Sentry.setTag("lending_application_uuid", applicationUuid);
    Sentry.setContext("lending_application", { uuid: applicationUuid });
  }, [applicationUuid]);

  return null;
}

export default LendingSentry;
